"use client";
import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { FilterSection } from "./FilterSection";
import { ActivityCard } from "./ActivityCard";
import { Pagination } from "./Pagination";
import { useDispatch, useSelector } from "react-redux";
import { fetchActivities } from "./processSlice";
import {
  ActivityStatus,
  ActivityFilterParams,
  ActivityOutputDTO,
} from "./types";
import { RootState } from "@app/store";
import { API_URL } from "@/config/api";
import { fetchProducts } from "../Element/productSlice";
import { fetchClients } from "../Client";
import moment from "moment";
import AtividadesModal from "./ActivityModal";
import { fetchDocuments } from "../document";

export const ActivityList = () => {
  const dispatch = useDispatch();
  const {
    items: proccess,
    loading,
    error,
  } = useSelector((state: RootState) => state.process);

  const [activities, setActivities] = useState<ActivityOutputDTO[]>([]);
  const [selectedProductId, setSelectedProductId] = useState<string | null>(
    null,
  );
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [forceload, setForceLoad] = useState<any>(null);

  const [activeFilter, setActiveFilter] = useState<
    "total" | "priority" | "delayed" | "completed"
  >("total");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(10);
  const [stats, setStats] = useState({});
  const { products: items } = useSelector((state: RootState) => state.product);

  const { items: documents } = useSelector((state: RootState) => {
    console.log("🔍 Selector executando, loading:", state.document.loading);
    return state.document;
  });

  const [selectedTime, setSelectedTime] = useState("today");

  const { items: clients } = useSelector((state: RootState) => {
    console.log("🔍 Selector executando, loading:", state.client.loading);
    return state.client;
  });

  const startDateRef: any = React.useRef(new Date());
  const endDateRef: any = React.useRef(null);

  // const [modal,setModal] = useState(false);

  const [selectClient, setSelectClient] = useState(null);

  // Status counts for filter section
  const [statusCounts, setStatusCounts] = useState({
    total: 0,
    priority: 0,
    delayed: 0,
    completed: 0,
    doneToday: 0,
    doneWeek: 0,
    doneMonth: 0,
    toBeDoneToday: 0,
    toBeDoneWeek: 0,
    toBeDoneMonth: 0,
  });

  const loadData = async () => {
    await dispatch(fetchProducts());
    await dispatch(fetchDocuments({}));

    await dispatch(fetchClients({}));
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    startDateRef.current = startDate;
  }, [startDate]);
  useEffect(() => {
    endDateRef.current = endDate;
  }, [endDate]);

  // Apply filters and fetch data
  useEffect(() => {
    const filters: ActivityFilterParams = {
      page: currentPage,
      limit: itemsPerPage,
    };

    if (selectedProductId) filters.product = selectedProductId;
    if (searchTerm) filters.search = searchTerm;

    if (startDate) {
      filters.startDate = startDate.toISOString();
    }

    if (endDate) {
      filters.endDate = endDate.toISOString();
    }

    // Apply status filter
    switch (activeFilter) {
      case "priority":
        filters.priority = true;
        break;
      case "delayed":
        filters.status = ActivityStatus.DELAYED;
        break;
      case "completed":
        filters.status = ActivityStatus.COMPLETED;
        break;
      // 'total' doesn't need any additional filter
    }

    // @ts-ignore - dispatch is correctly typed but TS isn't recognizing it
    // dispatch(fetchActivities(filters)).then(async(response) => {
    console.log(
      startDateRef.current?.toISOString(),
      endDateRef.current?.toISOString(),
    );
    fetch(
      API_URL +
        "/clients/get_client_products_filter?date_init=" +
        startDateRef.current?.toISOString() +
        "&date_end=" +
        endDateRef.current?.toISOString() +
        "&search=" +
        searchTerm +
        "&productId=" +
        selectedProductId,
      {
        headers: {
          Authorization: localStorage.getItem("token") || "",
          Accept: "application/json",
        },
      },
    ).then(async (resp) => {
      let clients_products = await resp.json();

      setActivities(clients_products.data);
    });

    fetch(API_URL + "/clients/get_client_products_stats", {
      headers: {
        Authorization: localStorage.getItem("token") || "",
        Accept: "application/json",
      },
    }).then(async (resp) => {
      let clients_products = await resp.json();
      setStats(clients_products.data);
    });

    // });
  }, [
    dispatch,
    selectedProductId,
    searchTerm,
    startDate,
    endDate,
    activeFilter,
    currentPage,
    itemsPerPage,
    forceload,
  ]);

  // Calculate status counts whenever activities array changes
  useEffect(() => {
    if (activities) {
      const counts = {
        total: activities.length,
        priority: activities?.filter((a) => a.priority).length,
        delayed: activities?.filter((a) => a.status === ActivityStatus.DELAYED)
          .length,
        completed: activities?.filter(
          (a) => a.status === ActivityStatus.COMPLETED,
        ).length,
        doneToday: 0, // In a real implementation, calculate these based on dates
        doneWeek: 0,
        doneMonth: 0,
        toBeDoneToday: 0,
        toBeDoneWeek: 0,
        toBeDoneMonth: 0,
      };

      setStatusCounts(counts);
    }
  }, [activities]);

  const handleProductChange = (productId: string | null) => {
    setSelectedProductId(productId);
    setCurrentPage(1); // Reset to first page on filter change
  };

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1); // Reset to first page on filter change
  };

  const handleDateChange = (start: Date | null, end: Date | null) => {
    startDateRef.current = start;
    endDateRef.current = end;
    console.log(start, end, "dateee");
    setStartDate(start);
    setEndDate(end);
    setCurrentPage(1); // Reset to first page on filter change
  };

  const handleFilterChange = (
    filter: "total" | "priority" | "delayed" | "completed",
  ) => {
    setActiveFilter(filter);
    setCurrentPage(1); // Reset to first page on filter change
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  console.log(clients);

  return (
    <div
      className={
        "flex flex-col flex-1 shrink  self-stretch  basis-0 min-w-60 max-md:px-5 bg-background-dark px-6 py-7"
      }
    >
      {selectClient != null && (
        <AtividadesModal
          products={items}
          documents={documents}
          selectClient={selectClient}
          setSelectClient={(e) => {
            setSelectClient(e);
            setForceLoad(Date.now());
          }}
        />
      )}
      <FilterSection
        stats={stats}
        totalActivities={statusCounts.total}
        totalPriorityActivities={statusCounts.priority}
        totalDelayedActivities={statusCounts.delayed}
        totalCompletedActivities={statusCounts.completed}
        totalDoneToday={statusCounts.doneToday}
        totalDoneWeek={statusCounts.doneWeek}
        totalDoneMonth={statusCounts.doneMonth}
        toBeDoneToday={statusCounts.toBeDoneToday}
        toBeDoneWeek={statusCounts.toBeDoneWeek}
        toBeDoneMonth={statusCounts.toBeDoneMonth}
        onProductChange={handleProductChange}
        onSearch={handleSearch}
        onDateChange={handleDateChange}
        onFilterChange={handleFilterChange}
        activeFilter={activeFilter}
        selectedTime={selectedTime}
        setSelectedTime={setSelectedTime}
      />
      <ActivityListWrapper className="custom-scrollbar">
        {loading && <LoadingMessage>Carregando atividades...</LoadingMessage>}

        {error && (
          <ErrorMessage>
            Erro ao carregar atividades: {error.message}
          </ErrorMessage>
        )}
        {!loading && !error && activities && activities.length > 0
          ? activities.map((activity: any) => {
              let client = clients?.data?.filter(
                (item) => item._id == activity.client_id,
              )[0];
              let product = items.filter(
                (item) => item._id == activity.productId,
              )[0];
              // startDateRef.current?.toISOString(),endDateRef.current?.toISOString())
              let phases_initial_1 = activity?.phases_init ?? {};

              let phases_initial_2 =
                Object.keys(phases_initial_1)?.filter((key: any) => {
                  let item = phases_initial_1[key];
                  return item.dates.filter((item2: any) => {
                    if (endDateRef.current) {
                      if (
                        startDateRef.current?.toISOString().split("T")[0] <=
                          item2.split("T")[0] &&
                        endDateRef.current?.toISOString().split("T")[0] >=
                          item2.split("T")[0]
                      ) {
                        return true;
                      }
                    } else {
                      if (
                        startDateRef.current?.toISOString().split("T")[0] <=
                        item2.split("T")[0]
                      ) {
                        return true;
                      }
                      return false;
                    }
                  }).length == 0
                    ? false
                    : true;
                }) ?? [];
              let allElements: any = [];
              let mapped_elements = phases_initial_2.map((item: any) => {
                let item_new: any = {};
                item_new = product?.phases
                  ?.map((item2, index_phase) => {
                    let elemen = item2.activities
                      .map((item3, index_activity) => {
                        if (item3._id == item) {
                          return {
                            ...item3,
                            index: index_activity + 1,
                            total: item2.activities.length,
                            index_phase: index_phase + 1,
                            total_phases: product?.phases?.length,
                          };
                        }
                        return -1;
                      })
                      .filter((item4) => item4 != -1);
                    if (elemen.length == 0) {
                      return -1;
                    } else {
                      return { phase: item2, activity: elemen[0] };
                    }
                  })
                  .filter((item2) => item2 != -1)[0];
                allElements.push(item_new);
              });

              if (allElements.length == 0) {
                allElements.push({
                  phase: product.phases[0],
                  activity: {
                    ...product.phases[0].activities[0],
                    index: 0,
                    total: product.phases[0].activities.length,
                    index_phase: 1,
                    total_phases: product.phases.length,
                  },
                });
              }

              // let phase = activity?.phases?.length == 0 ? { phase: product?.phases[0], index: 1 } : product?.phases.map((item, index) => {
              //   if (item.activities.filter((item2) => item2._id == activity.phases[activity.phases.length - 1]).length > 0) {
              //     return { phase: item, index: index + 1 }
              //   }
              //   return -1;
              // }).filter((item) => item != -1).at(-1)

              // let length_phase = product?.phases?.length

              // let activity_ = activity?.phases?.length == 0 ? 1 : product?.phases.filter((item) => item._id == phase?.phase?._id)[0]?.activities.map((item, index) => {
              //   console.log(activity.phases, item._id)
              //   if (item._id == activity.phases[activity.phases.length - 1]) {
              //     return index + 1;
              //   }
              //   else {
              //     return -1;
              //   }
              // }).filter((item2) => item2 != -1).at(-1)
              // console.log(activity.phases)
              // let duration = activity?.phases?.length == 0 ? product.phases[0].activities[0]?.duration : product?.phases.filter((item) => item._id == phase?.phase?._id)[0]?.activities.filter((item, index) => {
              //   if (item._id == activity.phases[activity.phases.length - 1]) {
              //     return true;
              //   }
              //   else {
              //     return false;
              //   }
              // }).filter((item2) => item2 != -1).at(-1)?.duration

              // let length_activities = activity?.phases?.length == 0 ? product?.phases[0].activities?.length : product?.phases.filter((item) => item._id == phase?.phase?._id)[0]?.activities?.length

              // console.log(activity_, length_activities)
              console.log(allElements);
              return allElements.map((item_new: any) => {
                return (
                  <ActivityCard
                    key={item_new.activity._id}
                    setSelectClient={() => setSelectClient({ client, product })}
                    avatar={
                      client?.im
                        ? client.im
                        : "https://microbiology.ucr.edu/sites/default/files/styles/form_preview/public/blank-profile-pic.png?itok=4teBBoet"
                    }
                    title={
                      item_new.activity.index_phase
                        .toString()
                        .padStart(2, "0") +
                      "/" +
                      item_new.activity.total_phases
                        .toString()
                        .padStart(2, "0") +
                      " - " +
                      item_new?.phase?.name
                    }
                    name={client?.name}
                    phone={client?.whatsapp}
                    product={product?.name}
                    activities={
                      item_new.activity.index.toString().padStart(2, "0") +
                      "/" +
                      item_new.activity.total.toString().padStart(2, "0")
                    }
                    time={item_new.activity.duration}
                    // filledForms={activity.filledForms}
                  />
                );
              });
            })
          : !loading &&
            !error && (
              <EmptyMessage>
                Nenhuma atividade encontrada com os filtros aplicados.
              </EmptyMessage>
            )}
      </ActivityListWrapper>
      {/* <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(statusCounts.total / itemsPerPage)}
        onPageChange={handlePageChange}
      /> */}
    </div>
  );
};

const ActivityContainer = styled.section`
  max-width: 1122px;
  width: 100%;
  flex: 1;
`;

const ActivityListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 26px;
  overflow-x: scroll;
  max-width: 100%;
`;

const EmptyMessage = styled.div`
  text-align: center;
  padding: 30px;
  background-color: #fcfcfc;
  border-radius: 14px;
  color: #7d8592;
  font-family:
    Inter,
    -apple-system,
    Roboto,
    Helvetica,
    sans-serif;
  font-size: 16px;
`;

const LoadingMessage = styled(EmptyMessage)`
  background-color: #f5f9ff;
`;

const ErrorMessage = styled(EmptyMessage)`
  background-color: #fff5f5;
  color: #e53e3e;
`;
